<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'    
    import _ from 'lodash'

    import _system from '../../../libs/system'

    import { removeChannel } from '../mixins/removeChannel'

	import { mapGetters, mapActions } from 'vuex'

    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';
	
	export default 
	{
        name: 'accountsFacebook',
        mixins: [removeChannel],
        data() 
        {
        	return {
                config: config,
                pages: [],
                pagesInstagram: [],
                debug: false,
                showEditPageName: false,
                loading: {
                    setGroup: false
                },
                loader: true
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole','getJwt', 'getWorkspace']),
	        ...mapGetters('accounts', ['accounts', 'accountsById', 'activeAccounts']),
	        ...mapGetters('tags', ['tagsByName', 'tagsById']),
	        ...mapGetters('workspaces', ['currentWorkspace']),
	        ...mapGetters('workspaceusers', ['workspaceusers']),
            ...mapGetters('networks', ['networks', 'networksByName']),
            onlyFbPages(){
                return _.filter(this.accounts, (e) => { 
                    return (e.platform == this.networksByName['Facebook']._id && (!e.tags || !e.tags.includes(this.tagsByName['Group']._id) )) 
                    });
            }
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            reAuth(){
               document.getElementById("auth").submit(); 
            },
            isFbGroup(page){
                if(page.tags){
                    return page.tags.includes(this.tagsByName['Group']._id);
                }else{
                    return false;
                }
            },
            updateChannelName(account){
                if(account.name.length == 0){ return alert('Input cannot be empty!')}
                let payload = {
                        query: {
                            pageId: account._id
                        },
                        body: {
                            name: account.name
                        }
                    }
                    _system.services.accounts.update(payload, (err, updatedChannel) => {
                        iziToast.success({
                            position: 'bottomCenter',
                            title: 'Saved ✅',
                        });
                    });  
            },
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
            
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            }
        }, 
        mounted(){
            $('.ui.dropdown').dropdown({
                'transition': 'scale'
              })

            $('.fbGroup').dropdown({
                transition: 'fade',
                onChange: (value, text, $choice) => {
  
                    let parsedValue = $choice[0].dataset
                    let payload = {
                        body:{
                            platform: parsedValue.platform,
                            type: '5c1a4a958db61a713724018e',
                            page: parsedValue.grouppageid,
                            value: 'page:' + parsedValue.fbpageid + '.value',
                            user: this.getUser._id
                        }
                    }

                    this.loading.setGroup = true;
                   
                    _system.services.accounts.setPageForGroup(payload, (err, res) => {
                        if (err) return alert(err.message);

                        let payload = {
                            query: {
                                pageId: parsedValue.grouppageid
                            },
                            body: {
                                "_id": parsedValue.fbpageid, 
                                "id": this.accountsById[parsedValue.fbpageid].id, 
                                "name": this.accountsById[parsedValue.fbpageid].name, 
                                "avatar": this.accountsById[parsedValue.fbpageid].avatar, 
                                "platform": this.accountsById[parsedValue.fbpageid].platform
                            }
                        }


                        _system.services.accounts.setPageParent(payload, (err, res) => {
                            if (err) return alert(err.message);

                            this.accounts[_.findIndex(this.accounts, { _id: res._id })].parent = res.parent
                            this.loading.setGroup = false;
                        });

                    });
                }
              })
        }, 
        created(){
    

            if(this.$route.query.debug == 'true'){
                this.debug = true;
            }

            //Store Fetching
 
            if(this.accounts){
                this.pages = _(this.accounts).filter((e) => { return e.platform == this.networksByName['Facebook']._id }).orderBy('tags', ['desc']).value();   
                this.pagesInstagram = _(this.accounts).filter((e) => { return e.platform == this.networksByName['Instagram']._id }).orderBy('tags', ['desc']).value();   
                this.loader = false;         
            }
        }
	}
</script>

<template>
	<span>


    <div style="background: #f5f5f5; margin-bottom: 1rem;" class="ui grid">
        <div class="twelve wide column">

            <form v-if="getRole.name == 'Admin'" id="auth" :action="config.url + '/facebook/auth'" method="post">

                <input type="text" name="state" :value="JSON.stringify({ 'userId': getUser._id, 'workspaceId': currentWorkspace._id })" hidden>

                <input type="text" name="accessToken" :value="getJwt" hidden>
                <input type="text" name="client_id" :value="'220505862059842'" hidden>
                
                <input type="text" name="redirect_uri" :value="config.url + '/facebook/redirect'" hidden>

                <input type="text" name="response_type" :value="'code'" hidden>

                <input type="text" name="access_type" :value="'offline'" hidden>

                <input type="text" name="prompt" :value="'consent'" hidden>

                <input type="text" name="scope" :value="'pages_manage_engagement,pages_manage_ads,pages_manage_posts,pages_show_list,pages_manage_metadata,pages_read_engagement,ads_management,pages_messaging,business_management'" hidden>

                <button type="submit" value="Submit" class="ui facebook button left floated"><i class="icon facebook"></i> Add Facebook Page </button>
            </form>

            <form style="margin-top:40px;" v-if="getRole.name == 'Admin' && debug" id="auth" :action="'https://graph.facebook.com/oauth/authorize'" method="get">

                <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>

                <input type="text" name="client_id" :value="'220505862059842'" hidden>
                
                <input type="text" name="redirect_uri" :value="'https://juphy-api.ngrok.io/facebook/redirect'" hidden>

                <input type="text" name="response_type" :value="'code'" hidden>

                <input type="text" name="access_type" :value="'offline'" hidden>

                <input type="text" name="prompt" :value="'consent'" hidden>

                <input type="text" name="scope" :value="'pages_manage_engagement,pages_manage_ads,pages_manage_posts,pages_show_list,pages_manage_metadata,pages_read_engagement,ads_management,pages_messaging,publish_to_groups,groups_access_member_info'" hidden>

                <button type="submit" value="Submit" class="ui black button"><i class="icon facebook"></i> Add Facebook Page [Developer Mode] </button>
            </form>
        </div>
        <div style="text-align: right;" class="four wide column">
        <span style="color:#ccc">v0.2</span>
        </div>
        </div>

        <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;font-style: italic;">
                Don't have any active Facebook Pages
            </p>
        </div>


        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled structured table fluid">
            <tbody>
            <tr v-for="account in pages" :key="account._id">
                <td style="min-width: 300px;"><h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}

                        <div v-if="showEditPageName" style="margin-left: 1rem;" class="ui action input">
                            <input type="text"  v-model="account.name" placeholder="Cannot be empty!">
                            <button class="ui button" @click="updateChannelName(account)">Save</button>
                        </div>
                        
                        <div v-if="isFbGroup(account)" style="background: #3B5998;" class="ui inverted small label">
                            <i class="facebook icon"></i>Group
                        </div>
                    </div>
                </h4></td>
                <td v-if="isFbGroup(account)" style="min-width: 250px;">        
                    <div :class="(loading.setGroup) ? 'loading disabled' : ''" class="ui fluid selection dropdown fbGroup">
                    <input type="hidden" name="user" :value="(account.parent) ? account.parent._id : ''">
                    <i class="dropdown icon"></i>
                    <div class="default text">Select Connected Page</div>
                    <div class="menu">
                    <div v-for="page in onlyFbPages" :key="page._id" class="item" :data-value="page._id" :data-groupPageId="account._id" :data-fbPageId="page._id"  :data-platform="page.platform">
                        <img class="ui mini avatar image" :src="page.avatar">
                        {{page.name}}

                    </div>
                    </div>
                    </div>
                </td>
                <td class="collapsing" style="vertical-align: bottom; text-align:right;">
               
                <div  v-if="account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1" class="ui compact warning small message" style="width:300px; text-align:left;">
                        <div class="header">Permissions Expired</div>
                        <p>Juphy can't access data for this channel. To regain data access, you have to re-authorize your account's permissions. 
                            <a :href="'#'" @click="reAuth()">Click here to re-authorize</a>
                        </p>
                    </div>
<!--                     <div v-if="getRole.name == 'Admin' && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->
                </td>
                <td class="collapsing">
                <div style="background: transparent;" class="ui left dropdown icon button">
                    <i class="ellipsis vertical icon"></i>
                    <div class="menu">
                        <div @click="(showEditPageName) ? showEditPageName = false : showEditPageName = true" class="item">Edit</div>
                        <div @click="deleteChannel(account._id)" class="item">
                        Delete
                        </div>
                    </div>
                    </div>
                </td>
<!--                               <td class="collapsing">
                    <a :href="'/account/settings/'+ account.id" class="ui basic small icon button more-basic"><i class="cog icon"></i></a>
                </td> -->
            </tr>
            
            </tbody>
        </table> 

	</span>
</template>

<style scoped >
.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}
.ui.table td.collapsing, .ui.table th.collapsing {
    width: 1px;
    white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/accounts/facebook.vue